import { can } from "@/plugins/can";
import { checkGestaoGuard } from "@/plugins/gestoesHelper";
import EditFichaDiarioAtendimento from "@/Pages/GestaoDeAulasAuxiliares/EditFichaDiarioAtendimento.vue";
import FichaDiarioAtendimento from "@/Pages/GestaoDeAulasAuxiliares/FichaDiarioAtendimento.vue";
import Index from "@/Pages/GestaoDeAulasAuxiliares/index.vue";
import NewCreateGestaoDeAuxiliares from "@/Pages/GestaoDeAulasAuxiliares/NewCreateGestaoDeAuxiliares.vue";
import relatorioAuxiliares from "@/Pages/GestaoDeAulasAuxiliares/relatorioAuxiliares.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    beforeEnter: (to, from, next) => {
      if (!can(["gestoesDeAulas.listar", "gestoesDeAulas.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return checkGestaoGuard("auxiliar")(to, from, next);
    },
    component: Index,
    name: "gestoesDeAulasAuxiliares",
    path: "/gestoes-de-aulas-auxiliares",
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.criar", "gestoesDeAulas.*"]),
    component: NewCreateGestaoDeAuxiliares,
    name: "gestoesDeAulasAuxiliares.newEdit",
    path: "/gestoes-de-aulas-auxiliares-create",
    props: { editing: false },
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.listar", "gestoesDeAulas.*"]),
    component: NewCreateGestaoDeAuxiliares,
    name: "gestoesDeAulasAuxiliares.edit",
    path: "/gestoes-de-aulas-auxiliares/edit/:gestaoDeAulasId",
    props: { editing: true },
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.listar", "gestoesDeAulas.*"]),
    component: relatorioAuxiliares,
    path: "/gestoes-de-aulas-auxiliares-relatorio/:gestaoId",
    name: "gestoesAuxiliaresRelatorio.newEdit",
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.listar", "gestoesDeAulas.*"]),
    component: FichaDiarioAtendimento,
    name: "gestoesDeAulasAuxiliares.fichaDiarioAtendimento",
    path: "/gestoes-de-aulas-auxiliares/ficha-diario-atend/:gestaoId",
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.listar", "gestoesDeAulas.*"]),
    component: EditFichaDiarioAtendimento,
    name: "fichaDiarioAtendimento.edit",
    path: "/gestoes-de-aulas-auxiliares/diario-atendimento/edit/:id/:gestaoId/:data",
    props: { editing: true },
  },
];
